import { IFileValidator, IListValidator, ITextValidator } from "../models/validator";
import { MaximumLengthValidator } from "./MaximumLengthValidator";
import { MaxFileSizeValidator } from "./maxSizeValidator";
import { MinimumLengthValidator } from "./minimumLengthValidator";
import { RequiredFileValidator, RequiredListValidator, RequiredValidator } from "./requiredValidator";
import { ValidUrlValidator } from "./validUrlValidator";

export const createValidators = () => {
  const baseList = new RequiredListValidator();
  const ronlList = new RequiredListValidator();
  ronlList.publicatieBestemming = "Rijksoverheid.nl";

  return {
    requiredDropdownValidations: [baseList] as IListValidator[],
    requiredDropdownValidationsRONL: [ronlList] as IListValidator[],
    requiredTextInputValidations: [new RequiredValidator(), new MinimumLengthValidator(3)] as ITextValidator[],
    textInputValidations: [new MinimumLengthValidator(3)] as ITextValidator[],
    textInputValidationsWithMaxLength200: [new MaximumLengthValidator(200)] as ITextValidator[],
    textInputValidationsWithMaxLength1000: [new MaximumLengthValidator(1000)] as ITextValidator[],
    fileInputValidations: [new RequiredFileValidator(), new MaxFileSizeValidator(2000)] as IFileValidator[],
    weblocatieValidations: [new ValidUrlValidator()] as ITextValidator[],
  };
};
